import { Pipe, PipeTransform } from '@angular/core';
import { Format } from 'src/app/shared/types/format.types';

@Pipe({
  name: 'appFormatTextFieldType',
  standalone: true,
})
export class FormatTextFieldTypePipe implements PipeTransform {
  public transform(textFieldType: Format.TextFieldType): string {
    return `AD_SLOTS.TEXT_FIELD_TYPE.${textFieldType}`;
  }
}
